// namespace:
var agi = agi || {};
agi.expressions = agi.expressions || {};

(function(Utils, CanvasController, BrightCoveVideoLoader, JLConfig) {
    "use strict";
    /**
     * JLVideo coordinates a VideoLoader
     * and CanvasController to render and control an jlvideo product.
     *
     * @class JLVideo
     * @constructor
     *
     * Based on IVEXManager
     */
    function JLVideo(opts) {
        this.initialize(opts);
    };

    var p = JLVideo.prototype;

    // public methods:


    /**
     * Initialization method.
     * @method initialize
     * @param {Object} opts Options to configure jlvideo content
     */
    p.initialize = function initialize(opts) {
        // default options:
        this.options = {
            env: null,
            contentDetails: null,
            imgPath: '',
            assetPath: '',
            mode: 'init',
            contentWrapperId: 'expression-mbox-wrapper',
            productContainer: 'product',
            expressionContainer: 'agi-expression-container',
            initialOverlayId: 'expression-overlay',
            playButtonId: 'expression-play-button',
            videoPlayerId: 'expression-vid-player',
            expressionWrapperId: 'expression-wrapper',
            expressionPlaceHolderId: 'expression-place-holder',
            expressionFullScreenLinkId: 'expression-full-screen-link',
            expressionInteractiveContainerId: 'expression-interactive-layer',
            originalZIndex: 1,
            elevatedZIndex: 500,
        };
        this.contentDetails = null;
        this.activeTriggerId = null;
        this.spinner = null;
        this.videoReady = false;
        this.canvasReady = false;
        this.videoLoader = null;
        this.canvasController = null;
        this.expressionInst = null;

        //containerId of the card
        this.containerId = null;

        this.options = Utils.extend(this.options, opts);
        this.contentDetails = this.options.contentDetails;
        this.env = this.options.env;

        this.expressionInst = this.options.expressionInst;

        this.setupComplete = false;

        if (this.checkReadyToSetup()) {
            this.setup();
        } else {
            var self = this;
            this.checkInterval = setInterval(function() {
                 if (self.checkReadyToSetup()) {
                     clearInterval(self.checkInterval);
                     self.setup();
                 }
            }, 500);
        }
        this.showSkipButton();
    };

    //Scaling handler that will call in to the canvas controller to change its scale
    p.scaleContent = function scaleContent(options) {
        this.canvasController.scaleContent();
    }

    //Check if our container is ready
    p.checkReadyToSetup = function checkReadyToSetup() {
        var containerId = this.options.productContainer; // "product"
        //Check container is suppose to be visible.
        //This is important for preview in custom.pd page
        var el = document.getElementById(containerId);
        if (el.offsetParent === null) {
            return false;
        } else {
            return true;
        }
    };

    /**
     * Destroy the instance
     */
    p.destroy = function destroy() {
        if (!this.setupComplete) {
            return;
        }

        var expressionWrapperId = this.options.expressionWrapperId;
        var expWrapper = document.getElementById(expressionWrapperId);

        if (expWrapper) {
            expWrapper.parentNode.removeChild(expWrapper);
        }

        if (!this.audioNotAvailable) {
            createjs.Sound.removeAllSounds();
        }

        if (this.videoLoader) {
            this.videoLoader.pause();
            this.videoLoader.removeEventListener("video-state-update", this);
            this.videoLoader.removeEventListener("video-time-update", this);
            this.videoLoader.removeEventListener("video-error", this);
            this.videoLoader.removeEventListener("endVideo", this);
            this.videoLoader.destroy();
            this.videoLoader = null;
        }

        if (this.canvasController) {
            this.canvasController.destroy();
            this.canvasController = null;
        }
    };


    //private methods
    /**
     * Setup videoLoader and CanvasController
     */
    p.setup = function setup() {
        //All of our containers
        var expressionWrapperId = this.options.expressionWrapperId; // "expression-wrapper"
        var placeHolderId = this.options.expressionPlaceHolderId; // "expression-placeholder"
        var originalZIndex = this.options.originalZIndex;

        this.containerId = this.options.productContainer; // "product"
        var productContainer = document.getElementById(this.containerId);

        //Get message and caption
        var message = this.formatMessageForDisplay(this.env.pers.Msg);

        var greeting = "";
        if (this.env.greeting !== undefined &&
            this.env.greeting.toLowerCase().indexOf("no caption") == -1) {
            greeting = this.env.greeting;
        }

        //Get our variables from the environment
        var videoData = JSON.parse(this.env.videoData);
        var productInfo = {
            imgHost:this.env.imghost,
            imgPath:this.env.imghost + this.env.contentMainPath + "/img/",
            width: this.env.largeX,
            height: this.env.largeY,
            videoId: videoData["data-video-id"],
            videoAccount: JLConfig.videoAccount,
            videoPlayer: JLConfig.videoPlayer,
            backgroundColor: this.env.backgroundColor,
            captionFontColor: this.env.captionFontColor,
            caption: greeting,
            message: message
        }

        //Apply product info
        var layout = AGI.templates.container(productInfo);
        productContainer.innerHTML = layout;

        //setup video
        this.videoLoader = new BrightCoveVideoLoader({containerId: this.options.videoPlayerId, videoData: this.env.videoData});
        this.videoLoader.addEventListener("videoStateUpdate", this);
        this.videoLoader.addEventListener("videoTimeUpdate", this);
        this.videoLoader.addEventListener("videoError", this);
        this.videoLoader.addEventListener("endVideo", this);


        // Audio here is we ever need it
        if (!createjs.Sound.initializeDefaultPlugins()) {
            this.audioNotAvailable = true;
            this.checkReady();
        }

        if (this.contentDetails.loopingAudio) {
            var audioPath = this.options.assetPath + this.contentDetails.loopingAudio;
            createjs.Sound.alternateExtensions = ["mp3"];
            createjs.Sound.addEventListener("fileload", this.audioLoadedHandler.bind(this));
            createjs.Sound.registerSound(audioPath, this.options.ambientSoundId);
        } else {
            this.audioNotAvailable = true;
            this.checkReady();
        }

        //setup canvas layer
        var contentWrapperId = this.options.contentWrapperId;
        var expressionWrapperId = this.options.expressionWrapperId;
        var expWrapper = document.getElementById(expressionWrapperId);

        this.canvasController = new CanvasController({env: this.env,
                                                product: this.contentDetails,
                                                width: this.env.largeX,
                                                height: this.env.largeY,
                                                containerId: this.options.expressionInteractiveContainerId});
        this.canvasController.addEventListener("canvasReady", this);
        this.canvasController.addEventListener("seekAndResumeVideo", this);
        this.canvasController.addEventListener("endVideo", this);
        this.canvasController.addEventListener("replay", this);
        this.canvasController.addEventListener("send", this);

        //Complete setup
        this.setupComplete = true;
    };

    /**
     * Video error handler
     */
    p.videoErrorHandler = function videoErrorHandler(eventData) {
        alert("Sorry, video load error, please reload the page and try again");
    };

    /**
     * Video state update handler
     */
    p.videoStateUpdateHandler = function videoStateUpdateHandler(eventData) {
        var currentState = eventData.state;
        if (currentState == "READY") {
            this.videoReady = true;
            this.checkReady();
        } else if (currentState == "SCREEN_CHANGE") {
            this.scaleContent();
        } else if (currentState == "COMPLETE") {
            this.skipToEnd();
        }
    };

    /**
     * Video time update handler
     */
    p.videoTimeUpdateHandler = function videoTimeUpdateHandler(eventData) {
        var vidCurTime = eventData.time;

        // if video has started hide initial_overlay(spinner, play button)
        if (vidCurTime > .19){
            document.getElementById(this.options.initialOverlayId).style.display = "none";
        }

    };

    /**
     * Check if video and canvas are ready to set up initial play button trigger
     */
    p.checkReady = function checkReady() {
	    if ((this.audioReady||this.audioNotAvailable)
             && this.videoReady && this.canvasReady){

            var self = this;
            this.scaleContent();

            //If there is a loader present, fade it out
            if(this.contentDetails.loader) {
                TweenLite.to(document.querySelector("#expression-inner-container .loader"),1,{alpha: 0, onComplete: this.onLoaderFadeOutComplete.bind(this)});
            }
            //Otherwise call the handler method immediately
            else {
                this.onLoaderFadeOutComplete();
            }
        }
    };

    p.onLoaderFadeOutComplete = function onLoaderFadeOutComplete() {
        //Check to see if we need turn graphic
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        if((windowHeight > windowWidth) && (windowWidth < 500)){
            //Create turn graphic div
            this.setupTurnGraphic();
            //Do a little hiding of other things
            var overlay = document.getElementById(this.options.initialOverlayId);
            overlay.style.visibility = "hidden";
            overlay.style.display = "none";
            //Set a timeout to fade away
            setTimeout(this.fadeTurnGraphic.bind(this),3000);
        }
        //Otherwise, display the overlay and wait for click
        else {
            var overlay = document.getElementById(this.options.initialOverlayId);
            overlay.style.visibility = "visible";
            overlay.style.display = "block";
            overlay.addEventListener("click", this.showVideo.bind(this));
            var videoLayer = document.getElementById(this.options.videoPlayerId);
            videoLayer.style.visibility = "visible";
        }
    }

    //Give properties to the turn graphic
    p.setupTurnGraphic = function setupTurnGraphic() {
        var turnGraphic = document.getElementById("turn-graphic");
        turnGraphic.style.backgroundImage = "url('" + this.env.imghost + this.env.contentMainPath + "/img/turn.png')";
        turnGraphic.style.backgroundSize = "contain";
        turnGraphic.style.backgroundRepeat = "no-repeat";
        turnGraphic.style.backgroundPosition = "center center";
        turnGraphic.style.backgroundColor = this.env.backgroundColor;

        turnGraphic.style.width = "100%";
        turnGraphic.style.height = "100%";
        turnGraphic.style.visibility = "visible";
        turnGraphic.style.display = "block";
        turnGraphic.style.position = "absolute";
    };
    
    //Fade out the turn graphic and then reveal the overlay
    p.fadeTurnGraphic = function fadeTurnGraphic() {
	    TweenLite.to(document.getElementById("turn-graphic"),1,{alpha: 0, onComplete: this.onTurnFadeOutComplete.bind(this)});
    };

    //Reveal overlay after a turn graphic
    p.onTurnFadeOutComplete = function onTurnFadeOutComplete() {
	    document.getElementById("turn-graphic").style.visibility = "hidden";
	    var overlay = document.getElementById(this.options.initialOverlayId);
        overlay.style.visibility = "visible";
        overlay.style.display = "block";
        overlay.addEventListener("click", this.showVideo.bind(this));
        var videoLayer = document.getElementById(this.options.videoPlayerId);
        videoLayer.style.visibility = "visible";
    };

    //Play the video immediately
    p.showVideo = function showVideo(event) {
        var overlay = document.getElementById(this.options.initialOverlayId);
        overlay.style.display = "none";

        if (this.videoLoader) {
            this.videoLoader.showVideo();
            this.videoLoader.play();
        }
    };

    /**
     * replay the card from the beginning
     */
    p.replayCard = function replayCard() {
        this.videoLoader.seekAndPlay(0);
        this.startOfCardHandler();
        this.canvasController.hideCanvas();
        this.videoLoader.showVideo();
    };

    /**
     * skip to end of the card
     */
    p.skipToEnd = function skipToEnd() {
        this.endOfCardHandler();
    };

    /**
     * send card and pass along the saved personalization
     */
    p.sendCard = function sendCard() {
        this.expressionInst.send('');
    };

    /**
     * startOfVideoHandler handles addition actions related to start of the card
     * Ideally we should have a separate manager to handle this for each site
     */
    p.startOfCardHandler = function startOfCardHander() {
        var skipToEndBtn = document.querySelector("#expression-skip-to-end-btn");
        var userMsg = document.querySelector("#expression-user-message");
        var caption = document.querySelector("#expression-caption");

        if (skipToEndBtn) {
            skipToEndBtn.style.display = "block";
        }
        if (userMsg) {
            userMsg.style.visibility = "hidden";
            Utils.removeClass([userMsg], "expression-oneSecondFadeIn");
        }
        if (caption) {
            caption.style.visibility = "hidden";
        }
    };

    /**
     * endOfVideoHandler handles additional actions related to end of the card
     * Ideally we should have a separate manager to handle this for each site
     */
    p.endOfCardHandler = function endOfCardHandler() {
        // Since the content may already be sized for fullscreen video,
        // rescale content to fit the smaller window when
        // playback has finished.
        this.scaleContent();
        this.canvasController.showCanvas();
        this.videoLoader.hideVideo();

        document.getElementById(this.options.initialOverlayId).style.display = "none";

        var skipToEndBtn = document.querySelector("#expression-skip-to-end-btn");
        var userMsg = document.querySelector("#expression-user-message");
        var caption = document.querySelector("#expression-caption");

        if (skipToEndBtn) {
            skipToEndBtn.style.display = "none";
        }

        if (userMsg) {
            userMsg.style.visibility = "visible";
            Utils.addClass([userMsg], "expression-oneSecondFadeIn");
        }

        if (caption) {
            caption.style.visibility = "visible";
        }
    };

    /**
     * show skip button
     * Ideally we should have a separate manager to handle this for each site
     */
    p.showSkipButton = function showSkipButton() {
        var skipToEndBtn = document.querySelector("#expression-skip-to-end-btn");
        if (skipToEndBtn) {
            skipToEndBtn.style.display = "block";
            Utils.addClass([skipToEndBtn], "expression-oneSecondFadeIn");
        }
    };

    /**
     * end skip button
     * Ideally we should have a separate manager to handle this for each site.
     * TODO only update as needed since this will be called with each timeUpdate
     * during video playback.
     */
    p.hideSkipButton = function hideSkipButton() {
        var skipToEndBtn = document.querySelector("#expression-skip-to-end-btn");
        if (skipToEndBtn) {
            skipToEndBtn.style.display = "none";
            Utils.removeClass([skipToEndBtn], "expression-oneSecondFadeIn");
        }
    };

    /**
     * routing of events received
     */
    p.handleEvent = function handleEvent(event) {
        switch (event.type) {
            case "videoStateUpdate":
                this.videoStateUpdateHandler(event.data);
                break;
            case "videoTimeUpdate":
                this.videoTimeUpdateHandler(event.data);
                break;
            case "videoError":
                this.videoErrorHandler(event.data);
                break;
            case "canvasReady":
                this.canvasReady = true;
                this.checkReady();
                break;
            case "seekAndResumeVideo":
                this.seekAndResumeVideo(event.data);
                break;
            case "endVideo":
                this.endOfCardHandler();
                break;
            case "replay":
                this.replayCard();
                break;
            case "resize":
                p.scaleContent();
                break;
            case "send":
                this.sendCard();
                break;
        };
    };

    /* Make the user-entered card message ready, and safe, for proper
       display in the DOM.

        @param String message  raw message with all escaping/encoding in tact
        @return fully formated string

            e.x.
    */
    p.formatMessageForDisplay = function formatMessageForDisplay(message) {
        if (message === undefined) {
            return '';
        }

        // remove encoding (used for HTTP transport)
        message = decodeURIComponent(message);

        // make string DOM-safe
        message = this.escapeString(message.replace(/\+/g, ' '));

        // handle line breaks
        message = message.replace(/\n/g, '<br>');

        return message;
    }

    /**
     * Escape a string to make it safe for insertion into the DOM
     * @param String value  potentially unsafe/risky user input
     * @return escaped string
     *
     *      e.x. <script>foo</script> --> &lt;script&gt;foo&lt;/script&gt;
     */
    p.escapeString = function escapeString(value) {
        var text = document.createTextNode(value);

        var div = document.createElement('div');
        div.appendChild(text);

        return div.innerHTML;
    };

    agi.expressions.JLVideo = JLVideo;

})(agi.expressions.Utils, agi.expressions.CanvasController,
   agi.expressions.BrightCoveVideoLoader, agi.expressions.JLConfig);
